import { isSiteSearchEnable } from '@tcp/core/src/utils/utils';
import { getABTestIsNewVendorEnabled } from '../../reduxStore/selectors/session.selectors';
import { getStoreRef } from '../../utils/store.utils';
import endpoints from '../endpoints';
import { executeUnbxdAPICall, executeStatefulAPICall } from './handler';
import { executeNewVendorAPICall } from './SSRHandler';

export const isNewVendorEnabled = () => {
  return isSiteSearchEnable();
};

const checkBackAbTestNewVendor = () => {
  const state = getStoreRef()?.getState() || {};
  const abTestVendorEnalbed = getABTestIsNewVendorEnabled(state);
  if (typeof abTestVendorEnalbed === 'string') {
    return abTestVendorEnalbed.toLowerCase() === 'true';
  }
  return !!abTestVendorEnalbed;
};

export const initiateApiCall = (reqObj, originalURL, xappURLConfig, config) => {
  const isNewVendorCall = isNewVendorEnabled();
  const IsNewVendorEnabledABTest = checkBackAbTestNewVendor();
  if (isNewVendorCall && IsNewVendorEnabledABTest) {
    // New search Vendor api call should be from here
    return executeNewVendorAPICall(reqObj, originalURL, xappURLConfig, config);
  }
  // Unbxd Api flow from here
  return executeUnbxdAPICall(reqObj, originalURL, xappURLConfig, config);
};

export const initiatePdpApiCall = (reqObj, originalURL, xappURLConfig, config) => {
  const isNewVendorCall = isNewVendorEnabled();
  if (isNewVendorCall) {
    const apiPayload = {
      webService: reqObj.body?.q
        ? endpoints.getProductDetailsById(reqObj.body?.q)
        : endpoints.getMultiProductsDetails(reqObj.body?.id),
    };
    // Rest pdp api call from here
    return executeStatefulAPICall(apiPayload, null, true);
  }
  // Unbxd Api flow from here
  return executeUnbxdAPICall(reqObj, originalURL, xappURLConfig, config);
};

export default { initiateApiCall, initiatePdpApiCall };
